import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  icon: string;
}

export function PlaceholderScreen({ title, icon }: Props) {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f0f4f8', fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12, background: '#fff', borderBottom: '1px solid #e8edf2' }}>
        <button onClick={() => navigate(-1)} style={{ fontSize: 22, background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: '#1464b4' }}>‹</button>
        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: '#1a2332' }}>{title}</h1>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 60, textAlign: 'center' }}>
        <span style={{ fontSize: 56, marginBottom: 16 }}>{icon}</span>
        <h2 style={{ margin: '0 0 8px', fontSize: 20, color: '#1a2332' }}>Bientôt disponible</h2>
        <p style={{ margin: 0, color: '#5a6a80', fontSize: 14, maxWidth: 280 }}>
          Cette section est en cours de développement. Elle sera disponible dans une prochaine mise à jour.
        </p>
      </div>
    </div>
  );
}
